import { toTypedRxJsonSchema } from 'rxdb';
import type { ExtractDocumentTypeFromTypedRxJsonSchema, RxJsonSchema } from 'rxdb';

export const serviceCategorySchemaLiteral = {
  title: 'service_category',
  version: 0,
  primaryKey: 'id',
  type: 'object',
  properties: {
    id: { type: 'string', maxLength: 100 },
    name: { type: 'string', maxLength: 100 },
    color: { type: 'string', maxLength: 7 },
    sort_order: { type: 'number', multipleOf: 1, minimum: 0, maximum: 10000 },
    branch_id: { type: ['string', 'null'], maxLength: 100 },
    created_at: { type: 'string', maxLength: 50 },
    updated_at: { type: 'string', maxLength: 50 },
    is_deleted: { type: 'boolean' },
    
    last_modified_by: { type: ['string', 'null'], maxLength: 100 },
  },
  required: ['id', 'name', 'sort_order', 'updated_at', 'is_deleted'],
  indexes: ['is_deleted', 'sort_order'],
} as const;

const schemaTyped = toTypedRxJsonSchema(serviceCategorySchemaLiteral);
export type ServiceCategoryDocType = ExtractDocumentTypeFromTypedRxJsonSchema<typeof schemaTyped>;
export const serviceCategorySchema: RxJsonSchema<ServiceCategoryDocType> = serviceCategorySchemaLiteral;
